import React from "react";
import { Typography, Divider, Tag } from "antd";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import {
  Brain,
  Rocket,
  Shield,
  Users,
  Lightbulb,
  Code,
  Target,
  Globe,
  PhoneCallIcon,
} from "lucide-react";

const { Title, Text, Paragraph } = Typography;

const About = () => {
  // 团队成员数据
  const teamMembers = [
    {
      name: "张博士",
      role: "创始人 & CEO",
      description: "人工智能领域专家，拥有10年以上AI研究经验",
      image: "https://via.placeholder.com/150",
    },
    {
      name: "李工程师",
      role: "CTO",
      description: "资深软件工程师，曾主导多个大型AI项目开发",
      image: "https://via.placeholder.com/150",
    },
    {
      name: "王研究员",
      role: "算法总监",
      description: "机器学习专家，专注于深度学习和强化学习研究",
      image: "https://via.placeholder.com/150",
    },
    {
      name: "赵设计师",
      role: "产品设计总监",
      description: "用户体验专家，致力于打造优秀的AI产品",
      image: "https://via.placeholder.com/150",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-blue-300 to-indigo-100 py-16 pt-20 pb-10">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <Title level={1} className="mb-4">
                关于我们
              </Title>
              <div className="text-gray-600 py-6 text-base">
                Stabilize如动科技，成立于2023年，是世界领先的人工智能技术科技公司。我们基于人工智能技术新理论，指导如何去实现真正的人工智能技术，并由此诞生的人工智能技术产品，可以被广泛的应用在自动化、机器人和智慧世界领域。
              </div>
              {/* <div className="flex gap-4 mt-2 mb-6">
                <Button variant="blue-griadient" size="lg">
                  了解更多
                </Button>
                <Button variant="secondary" size="lg">
                  联系我们
                </Button>
              </div> */}
            </div>
            <div className="md:w-1/2 max-w-[560px]">
              <img src={require("../assets/img/about_hero.webp")} />
            </div>
          </div>
        </div>
      </section>

      {/* Company Introduction */}
      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 uppercase rounded-full shadow-sm">
              公司介绍
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              世界领先的人工智能技术科技公司
            </h2>
            <p className="text-base md:text-lg text-slate-500">
              Stabilize如动科技基于人工智能技术新理论，指导如何去实现真正的人工智能技术，并由此诞生的人工智能技术产品，可以被广泛的应用在自动化、机器人和智慧世界领域。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-12 w-12 items-center justify-center text-white bg-blue-600 rounded-lg flex-shrink-0">
                    <Brain className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-800 mb-2">
                      我们的使命
                    </h3>
                    <p className="text-slate-600">
                      建立真正的人工智能，创造真正的机械"生命"，推动人工智能技术的进步，造福人类。
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-12 w-12 items-center justify-center text-white bg-blue-600 rounded-lg flex-shrink-0">
                    <Globe className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-800 mb-2">
                      我们的愿景
                    </h3>
                    <p className="text-slate-600">
                      成为通用人工智能领域的领头羊，让智慧世界连接你我，创造更美好的未来。
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-12 w-12 items-center justify-center text-white bg-blue-600 rounded-lg flex-shrink-0">
                    <Target className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-800 mb-2">
                      我们的目标
                    </h3>
                    <p className="text-slate-600">
                      通过持续创新和技术突破，实现人工智能技术的广泛应用，推动各行业数字化转型。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img src={require("../assets/img/about-team.webp")} />
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="bg-gray-100 py-24">
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 uppercase rounded-full shadow-sm">
              核心价值观
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              引领AI技术创新，创造智能未来
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: <Lightbulb className="w-8 h-8" />,
                title: "创新",
                description: "敢于尝试和创新，以超前的想法铸就人工智能的明天",
              },
              {
                icon: <Code className="w-8 h-8" />,
                title: "技术",
                description:
                  "拥有强大的编程能力和技术底蕴，利用自身技术为行业赋能",
              },
              {
                icon: <Users className="w-8 h-8" />,
                title: "团队",
                description:
                  "团队氛围融洽，组员来自全国一线技术团队，扁平化管理",
              },
              {
                icon: <Shield className="w-8 h-8" />,
                title: "责任",
                description: "致力于推动人工智能技术的进步，造福人类社会",
              },
            ].map((value, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
              >
                <div className="inline-flex h-12 w-12 mb-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {value.title}
                </h3>
                <p className="text-slate-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Members */}
      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 uppercase rounded-full shadow-sm">
              我们的团队
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              专业的AI研发团队
            </h2>
            <p className="text-base md:text-lg text-slate-500">
              我们拥有一支来自全球各地的专业研发团队，致力于推动人工智能技术的突破和创新
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-1">
                    {member.name}
                  </h3>
                  <p className="text-blue-600 mb-3">{member.role}</p>
                  <p className="text-slate-600 text-sm">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Us */}
      <section className="relative py-24">
        <div
          className="absolute inset-0 bg-blue-600 bg-center bg-cover"
          style={{ backgroundImage: "url('/img/pattern-blue.svg')" }}
        ></div>
        <div className="relative container text-center text-white py-20 z-10">
          <div className="md:max-w-5xl mb-12 mx-auto">
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight">
              加入我们，实现真正的人工智能技术
            </h2>
            <p className="text-base md:text-lg text-blue-100 mb-12">
              见证人工生命的诞生，与我们一起推动人工智能技术的进步
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="secondary" size="lg">
              <PhoneCallIcon />
              联系我们
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
